import isNativeApp from "./isNativeApp";

/**
 * hapticTap — fire a light haptic on a native device, no-op on web.
 *
 * The @capacitor/haptics plugin is imported lazily inside the native branch so
 * the production web bundle never resolves it at module-eval time. Any failure
 * (plugin missing, unsupported device) is swallowed — haptics are a nicety,
 * never a code path the UI depends on.
 *
 * @param {"Light"|"Medium"|"Heavy"} style — impact strength (default "Light").
 */
export async function hapticTap(style = "Light") {
  if (!isNativeApp()) return;
  try {
    const { Haptics, ImpactStyle } = await import("@capacitor/haptics");
    await Haptics.impact({ style: ImpactStyle[style] || ImpactStyle.Light });
  } catch (_e) {
    /* haptics unavailable — ignore */
  }
}

export default hapticTap;
